import {Grid, GridItem, Hr, Link} from '@constellation/core';
import {Fragment, memo} from 'react';
import breakPoint from '../../../../../utils/breakPoint.js';
import {OTHER_DETAILS} from '../../../../../utils/constants/public/psr.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import {
  DetailsGrid,
  OtherSectionDiv,
  OtherSectionHeading,
  OtherSectionText,
  OtherSectionValues,
} from '../Styles/Styles.js';

const OtherDetails = memo((props: any) => {
  const {details} = props;

  return (
    <div aria-describedby={OTHER_DETAILS} role='table'>
      <OtherSectionDiv bgColor='neutral2'>
        <OtherSectionHeading marginBottom='02' marginLeft='02' size='s3'>
          <div id={OTHER_DETAILS}>
            {getPsrLabel(
              'cardPaymentServicesDetails.otherSection.otherDetails.labelText'
            )}
          </div>
        </OtherSectionHeading>

        <div role='rowgroup'>
          <DetailsGrid>
            <GridItem xs={12}>
              <div role='row'>
                <Grid>
                  <GridItem md={8} xs={7}>
                    <OtherSectionText>
                      <div role='rowheader'>
                        {getPsrLabel(
                          'cardPaymentServicesDetails.otherSection.otherDetails.labels.label1'
                        )}
                        <small>
                          <sup>
                            <Link
                              aria-label={`footnote ${getPsrLabel(
                                'cardPaymentServicesDetails.otherSection.otherDetails.labels.label1Ref'
                              )}`}
                              href='#fundstoreachaccount'
                              id={`fundstoreachaccount-ref${breakPoint}`}
                            >
                              {getPsrLabel(
                                'cardPaymentServicesDetails.otherSection.otherDetails.labels.label1Ref'
                              )}
                            </Link>
                          </sup>
                        </small>
                      </div>
                    </OtherSectionText>
                  </GridItem>
                  <OtherSectionValues md={4} xs={5}>
                    <OtherSectionText>
                      <div role='cell'>{details.time}</div>
                    </OtherSectionText>
                  </OtherSectionValues>
                </Grid>
              </div>
              <Hr aria-hidden={true} marginBottom='01' marginTop='01' />
            </GridItem>

            <GridItem xs={12}>
              <div role='row'>
                <Grid>
                  <GridItem md={6} xl={7} xs={7}>
                    <OtherSectionText>
                      <div role='rowheader'>
                        {getPsrLabel(
                          'cardPaymentServicesDetails.otherSection.otherDetails.labels.label2'
                        )}
                      </div>
                    </OtherSectionText>
                  </GridItem>
                  <OtherSectionValues md={6} xl={5} xs={5}>
                    <div role='cell'>
                      {details.brands.map((brand) => (
                        <Fragment key={brand}>
                          <OtherSectionText>{brand}</OtherSectionText>
                          <br />
                        </Fragment>
                      ))}
                    </div>
                  </OtherSectionValues>
                </Grid>
              </div>
            </GridItem>
          </DetailsGrid>
        </div>
      </OtherSectionDiv>
    </div>
  );
});

export default OtherDetails;
